export function categorySearch() {
    const searchInput = document.getElementById("category-search-input");
    const resultsContainer = document.getElementById("category-search-results");

    if (!searchInput || !resultsContainer) return;

    let categories = [];

    // Fetch categories dynamically from WordPress
    fetch("/wp-admin/admin-ajax.php?action=get_categories")
        .then(response => response.json())
        .then(data => {
            categories = data;
        });

    // Listen for input in the search field
    searchInput.addEventListener("input", function () {
        const query = this.value.toLowerCase().trim();
        resultsContainer.innerHTML = "";

        if (query.length === 0) {
            resultsContainer.style.display = "none";
            return;
        }

        const filtered = categories.filter(cat => cat.name.toLowerCase().includes(query));

        filtered.forEach(cat => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${cat.link}">${cat.name}</a>`;
            resultsContainer.appendChild(li);
        });

        resultsContainer.style.display = filtered.length ? "block" : "none";
    });

    // Hide results when clicking outside
    document.addEventListener("click", function (e) {
        if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
            resultsContainer.style.display = "none";
        }
    });
}
